import { render, staticRenderFns } from "./InformeMain.vue?vue&type=template&id=3c1ae079&scoped=true&"
import script from "./InformeMain.vue?vue&type=script&lang=js&"
export * from "./InformeMain.vue?vue&type=script&lang=js&"
import style0 from "./InformeMain.vue?vue&type=style&index=0&id=3c1ae079&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1ae079",
  null
  
)

export default component.exports